export function toOptions<T>(
  items: readonly T[] | undefined,
  nameKey: keyof T,
  valueKey: keyof T
): readonly { name: string; value: string }[] {
  return Array.isArray(items)
    ? items
        .map(item => ({
          name: String(item[nameKey] ?? ''),
          value: String(item[valueKey] ?? '')
        }))
        .filter(o => o.value.length > 0)
    : [];
}

export function toOptionsWithSort<T>(
  items: readonly T[] | undefined,
  nameKey: keyof T,
  valueKey: keyof T
): readonly { name: string; value: string }[] {
  return Array.isArray(items)
    ? items
        .map(item => ({
          name: String(item[nameKey] ?? ''),
          value: String(item[valueKey] ?? '')
        }))
        .filter(o => o.value.length > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
    : [];
}
